import BaseApi from '@/api/controller/base';

const API_URL = '3p-docutax/request';

class DocutaxSubmissionsApi extends BaseApi {
  constructor() {
    super(API_URL);
  }

  findAllAvailableClients() {
    return this.api.get('client');
  }

  findClientByPhoneNumber(phone) {
    return this.api.post('phone-number-lookup', {
      phone,
    });
  }

  search(filters) {
    return this.api.post('search', filters);
  }

  create(createDto) {
    return this.api.post('', createDto);
  }
}

const apiInstance = new DocutaxSubmissionsApi();
export { DocutaxSubmissionsApi, apiInstance };
export default apiInstance;
